import { FC } from 'react';
import { useIntroduction } from '../../services/graph/hooks/introduction';
import { ImagePreloader } from './ImagePreloader';

export const HeaderImagesPreload: FC = () => {
  const introduction = useIntroduction();

  if (!introduction.data) {
    throw Error('Could not get introduction data');
  }

  const imagesToLoad: string[] = [
    introduction.data.backgroundImages.documentsPage,
    introduction.data.backgroundImages.notFoundPage,
    introduction.data.backgroundImages.searchPage,
    ...introduction.data.backgroundImages.homePage
  ];

  return (
    <>
      {imagesToLoad.map((url, index) => (
        <ImagePreloader url={url} key={`${url}+${index}`} />
      ))}
    </>
  );
};
